export default __webpack_public_path__ + "static/media/peer_logo.7d033102.png";